

























































import { Component, Prop, Vue } from 'vue-property-decorator';
import L from 'leaflet';
import { Listing } from '../models/Listing';

@Component
export default class WalkTimes extends Vue {

    public walkTimeControl: any = null;
    public walkAreasLayer: any = null;
    public walkData: any = null; // as GeoJsonObject
    public sysId: number | null = null;

    public showDialog: boolean = false;
    public dontTellMe: boolean = false;

    get config() {
        return this.$store.state.config;
    }

    get map() {
        return this.$store.state.map;
    }

    get showWalkabilityHelp(): boolean {
        return this.$store.state.showWalkabilityHelp;
    }

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'initWalkTimes') {
            this.initWalkTimes();
        }
        if (action.type === 'setSelectedListing') {
            this.onListingSelected(action.payload);
        }
        if (action.type === 'listingDetailFetchComplete') {
            if (action.payload && action.payload.ParcelData && action.payload.ParcelData.WalkTimeGeoJson) {
                const walkData = JSON.parse(action.payload.ParcelData.WalkTimeGeoJson);
                console.log(walkData);
                this.onSetWalkData(walkData);
            } else {
                this.onClearWalkData();
            }
        }

    });

    public onChangeHelp(value: boolean) {
        console.log(value);
        this.$store.dispatch('setWalkabilityHelp', !value);
    }

    public initWalkTimes() {
        console.log('WalkTimes: initWalkTimes()');

        this.dontTellMe = !this.showWalkabilityHelp;

        const WalkTimeControl = L.Control.extend({
            options: {
                position: 'topleft',
            },

            onAdd: () => {
                console.log('WalkTimeControl: onAdd()');
                const container = L.DomUtil.create('div', 'divWalkTimeControl');
                container.innerHTML =
                    `<span id='spanWalkTimeControl' class='spanWalkTimeControl' title='Walk Times'>` +
                    `<i class='fas fa-walking fa-2x'></i>` +
                    `</span>`;

                container.style.display = 'none';
                return container;
            },
        });

        this.walkTimeControl = new WalkTimeControl();
        this.map.addControl(this.walkTimeControl);

        // initiall invisible
        const favBtn: any = document.getElementById('spanWalkTimeControl');
        favBtn.addEventListener('click', (event: any) => {
            this.$store.dispatch('sendWalkabilityEvent', { sysId: this.sysId });

            if (this.walkAreasLayer && this.map.hasLayer(this.walkAreasLayer)) {
                this.map.removeLayer(this.walkAreasLayer);
                return;
            }

            if (this.showWalkabilityHelp) {
                this.showDialog = true;
            }

            this.showWalkData();

            event.preventDefault();
        });
    }

    public onClearWalkData() {
        if (this.walkAreasLayer !== null) {
            this.walkAreasLayer.removeFrom(this.map);
            this.walkAreasLayer = null;
        }
    }

    public onListingSelected(listing: Listing) {
        console.log('WalkTimes: onListingSelected');
        console.log(listing);
        if (this.sysId !== null && this.sysId !== listing.sid && this.walkTimeControl) {
            this.walkTimeControl.getContainer().style.display = 'none';
        }
        this.sysId = listing.sid;
    }

    public onSetWalkData(walkData: any) {

        this.walkTimeControl.getContainer().style.display = 'block';

        if (this.walkAreasLayer) {
            this.walkAreasLayer.removeFrom(this.map);
        }

        this.walkData = walkData;

        this.walkAreasLayer = L.geoJSON(walkData, {
            // @ts-ignore - not sure what feature should be
            style: (feature: any) => {
                switch (feature.properties.FromBreak) {
                    case 0: return {
                        color: '#A4D7F4',
                        weight: 1,
                        fillOpacity: 0.65,
                    };
                    case 5: return {
                        color: '#DC1C2E',
                        weight: 1,
                        fillOpacity: 0.65,
                    };
                    case 10: return {
                        color: '#0043ff',
                        weight: 1,
                        opacity: 1,
                        fillOpacity: 0.65,
                    };
                }
            },
        });

    }


    public showWalkData() {
        if (this.walkAreasLayer && this.map.hasLayer(this.walkAreasLayer)) {
            return;
        }

        if (!this.walkData) {
            console.error('Trying to show walk data without data?');
            // ErrorMgr.logError("Trying to show walk data without data?");
            return;
        }

        this.onSetWalkData(this.walkData);
        this.walkAreasLayer.addTo(this.map);
        this.map.flyToBounds(this.walkAreasLayer.getBounds());
    }


    public mounted() {
        console.log('WalkTimes: mounted()');
    }

}

